module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('figure', {
    directives: [{
      name: "weex-resize",
      rawName: "v-weex-resize",
      value: (_vm.resize),
      expression: "resize"
    }],
    staticClass: " weex-el weex-image",
    style: ({
      'border-radius': _vm._px2rem(_vm.radius, 75),
      'width': _vm._px2rem(_vm.width, 75),
      'height': _vm._px2rem(_vm.height, 75)
    }),
    attrs: {
      "src": _vm.imagePath,
      "placeholder": _vm.placeholderPath,
      "resize": _vm.resize,
      "data-img-src": _vm.imagePath,
      "weex-type": "image",
      "data-evt-click": "",
      "data-evt-load": ""
    },
    on: {
      "click": _vm.$stopOuterA,
      "load": function($event) {
        return _vm._load()
      },
      "weex$tap": function($event) {
        $event.stopPropagation();
        return _vm._click($event)
      }
    }
  })
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-7f070f56", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7f070f56","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./packages/dof-image/index.vue
// module id = 636
// module chunks = 0 1